/**
 * Application Quick View - Lightweight projection for dashboards.
 */
import { z } from 'zod';
import { ApplicationId } from '../types/branded';
import { ApplicationDocumentSchema } from './document';
import { TimelineEventSchema } from './timeline';

export const QuickViewStudentSchema = z.object({
  id: z.string(),
  firstName: z.string(),
  lastName: z.string(),
  gradeApplying: z.string(),
  dateOfBirth: z.number().int().nullable().optional(),
});
export type QuickViewStudent = z.infer<typeof QuickViewStudentSchema>;

export const ApplicationQuickViewSchema = z.object({
  applicationId: ApplicationId,
  familyName: z.string(),
  referenceCode: z.string(),
  students: z.array(QuickViewStudentSchema),
  documents: z.array(ApplicationDocumentSchema).default([]),
  timeline: z.array(TimelineEventSchema).default([]),
});
export type ApplicationQuickView = z.infer<typeof ApplicationQuickViewSchema>;
